export default function usageReportEndpointConverter({ data }) {
  return {
    usage: data.attributes.usage,
    totalUsage: data.attributes['total-usage'],
  }
}
